import { apiRequest } from "./api";

export interface UserMatter {
  matter_id: number;
  project_name: string;
}

export async function fetchUserMatters(userId: number): Promise<UserMatter[]> {
  const response = await apiRequest<{ data?: UserMatter[] }>(
    `/matters/user-matters/${userId}`
  );
  return response.data ?? [];
}
